import { Directive, HostBinding, HostListener } from '@angular/core';

@Directive({
  standalone: false,
  selector: 'kendo-dropdownlist, kendo-combobox, combobox, [tiFocusWithin]',
})
export class FocusWithinDirective {
  @HostBinding('class.ti-focus') isFocusWithin = false;

  @HostListener('focusin') onFocusin() {
    this.isFocusWithin = true;
  }

  @HostListener('focusout') onFocusout() {
    this.isFocusWithin = false;
  }
}
